var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0985 93.8244C73.0075 93.8244 93.9691 72.8211 93.9177 46.9122C93.8663 21.0033 72.8213 0 46.9123 0C21.0034 0 0.0416817 21.0033 0.0930987 46.9122C0.144516 72.8211 21.1896 93.8244 47.0985 93.8244Z",
    fill: "url(#paint0_linear_3114_3068)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 46.7512C5.875 24.091 24.3078 5.6582 46.968 5.6582C69.6282 5.6582 88.061 24.091 88.061 46.7512C88.061 69.4114 69.6282 87.8442 46.968 87.8442C24.3078 87.8442 5.875 69.4114 5.875 46.7512Z",
    fill: "#75609F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3064 25H32.2419C32.058 25 31.8816 25.0731 31.7515 25.2031C31.6215 25.3332 31.5484 25.5096 31.5484 25.6935V45.8065H26.6935C26.5096 45.8065 26.3332 45.8795 26.2031 46.0096C26.0731 46.1397 26 46.3161 26 46.5V67.3064C26 67.4904 26.0731 67.6668 26.2031 67.7969C26.3332 67.9269 26.5096 68 26.6935 68H47.5C47.6839 68 47.8603 67.9269 47.9904 67.7969C48.1205 67.6668 48.1935 67.4904 48.1935 67.3064V62.4516H68.3064C68.4904 62.4516 68.6668 62.3785 68.7969 62.2485C68.9269 62.1184 69 61.942 69 61.7581V25.6935C69 25.5096 68.9269 25.3332 68.7969 25.2031C68.6668 25.0731 68.4904 25 68.3064 25ZM46.8065 66.6129H27.3871V47.1935H46.8065V66.6129ZM52.8452 34.9129L50.5613 32.629H61.371V43.4387L59.0871 41.1548C58.9571 41.0248 58.7807 40.9518 58.5968 40.9518C58.4129 40.9518 58.2365 41.0248 58.1064 41.1548L48.1935 51.0677V46.5C48.1935 46.3161 48.1205 46.1397 47.9904 46.0096C47.8603 45.8795 47.6839 45.8065 47.5 45.8065H42.9323L52.8452 35.8936C52.9752 35.7635 53.0482 35.5871 53.0482 35.4032C53.0482 35.2193 52.9752 35.0429 52.8452 34.9129ZM67.6129 61.0645H48.1935V53.0291L58.5968 42.6258L61.5742 45.6032C61.6712 45.7002 61.7947 45.7662 61.9293 45.793C62.0638 45.8197 62.2032 45.806 62.3299 45.7535C62.4566 45.701 62.5649 45.6122 62.6411 45.4981C62.7173 45.3841 62.758 45.2501 62.7581 45.1129V31.9355C62.7581 31.7515 62.685 31.5751 62.5549 31.4451C62.4249 31.315 62.2485 31.2419 62.0645 31.2419H48.8871C48.7499 31.242 48.6159 31.2827 48.5019 31.3589C48.3878 31.4351 48.299 31.5434 48.2465 31.6701C48.194 31.7968 48.1803 31.9362 48.207 32.0707C48.2338 32.2053 48.2998 32.3288 48.3968 32.4258L51.3742 35.4032L40.9709 45.8065H32.9355V26.3871H67.6129V61.0645Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3223 27.7734H35.7094V29.1605H34.3223V27.7734Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0977 27.7734H38.4848V29.1605H37.0977V27.7734Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8711 27.7734H41.2582V29.1605H39.8711V27.7734Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6445 27.7734H44.0316V29.1605H42.6445V27.7734Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4199 27.7734H46.807V29.1605H45.4199V27.7734Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1934 27.7734H49.5805V29.1605H48.1934V27.7734Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9668 27.7734H52.3539V29.1605H50.9668V27.7734Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7422 27.7734H55.1293V29.1605H53.7422V27.7734Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5156 27.7734H57.9027V29.1605H56.5156V27.7734Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.291 27.7734H60.6781V29.1605H59.291V27.7734Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0645 27.7734H63.4515V29.1605H62.0645V27.7734Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9668 58.291H52.3539V59.6781H50.9668V58.291Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7422 58.291H55.1293V59.6781H53.7422V58.291Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5156 58.291H57.9027V59.6781H56.5156V58.291Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.291 58.291H60.6781V59.6781H59.291V58.291Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0645 58.291H63.4515V59.6781H62.0645V58.291Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 27.7734H66.225V29.1605H64.8379V27.7734Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 30.5488H66.225V31.9359H64.8379V30.5488Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 33.3223H66.225V34.7094H64.8379V33.3223Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 36.0977H66.225V37.4848H64.8379V36.0977Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 38.8711H66.225V40.2582H64.8379V38.8711Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 41.6445H66.225V43.0316H64.8379V41.6445Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3223 30.5488H35.7094V31.9359H34.3223V30.5488Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3223 33.3223H35.7094V34.7094H34.3223V33.3223Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3223 36.0977H35.7094V37.4848H34.3223V36.0977Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3223 38.8711H35.7094V40.2582H34.3223V38.8711Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3223 41.6445H35.7094V43.0316H34.3223V41.6445Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 44.4199H66.225V45.807H64.8379V44.4199Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 47.1934H66.225V48.5805H64.8379V47.1934Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 49.9668H66.225V51.3539H64.8379V49.9668Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 52.7422H66.225V54.1293H64.8379V52.7422Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 55.5156H66.225V56.9027H64.8379V55.5156Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 58.291H66.225V59.6781H64.8379V58.291Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.467 52.7414H32.2412C32.4251 52.7414 32.6015 52.6683 32.7316 52.5382C32.8617 52.4082 32.9347 52.2318 32.9347 52.0478V49.2736C32.9347 49.0897 32.8617 48.9133 32.7316 48.7832C32.6015 48.6531 32.4251 48.5801 32.2412 48.5801H29.467C29.283 48.5801 29.1066 48.6531 28.9766 48.7832C28.8465 48.9133 28.7734 49.0897 28.7734 49.2736V52.0478C28.7734 52.2318 28.8465 52.4082 28.9766 52.5382C29.1066 52.6683 29.283 52.7414 29.467 52.7414ZM30.1605 49.9672H31.5476V51.3543H30.1605V49.9672Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9514 52.7414H44.7256C44.9095 52.7414 45.0859 52.6683 45.216 52.5382C45.346 52.4082 45.4191 52.2318 45.4191 52.0478V49.2736C45.4191 49.0897 45.346 48.9133 45.216 48.7832C45.0859 48.6531 44.9095 48.5801 44.7256 48.5801H41.9514C41.7674 48.5801 41.591 48.6531 41.4609 48.7832C41.3309 48.9133 41.2578 49.0897 41.2578 49.2736V52.0478C41.2578 52.2318 41.3309 52.4082 41.4609 52.5382C41.591 52.6683 41.7674 52.7414 41.9514 52.7414ZM42.6449 49.9672H44.032V51.3543H42.6449V49.9672Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9514 65.2257H44.7256C44.9095 65.2257 45.0859 65.1527 45.216 65.0226C45.346 64.8925 45.4191 64.7161 45.4191 64.5322V61.758C45.4191 61.5741 45.346 61.3977 45.216 61.2676C45.0859 61.1375 44.9095 61.0645 44.7256 61.0645H41.9514C41.7674 61.0645 41.591 61.1375 41.4609 61.2676C41.3309 61.3977 41.2578 61.5741 41.2578 61.758V64.5322C41.2578 64.7161 41.3309 64.8925 41.4609 65.0226C41.591 65.1527 41.7674 65.2257 41.9514 65.2257ZM42.6449 62.4515H44.032V63.8386H42.6449V62.4515Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29.467 65.2257H32.2412C32.4251 65.2257 32.6015 65.1527 32.7316 65.0226C32.8617 64.8925 32.9347 64.7161 32.9347 64.5322V61.758C32.9347 61.5741 32.8617 61.3977 32.7316 61.2676C32.6015 61.1375 32.4251 61.0645 32.2412 61.0645H29.467C29.283 61.0645 29.1066 61.1375 28.9766 61.2676C28.8465 61.3977 28.7734 61.5741 28.7734 61.758V64.5322C28.7734 64.7161 28.8465 64.8925 28.9766 65.0226C29.1066 65.1527 29.283 65.2257 29.467 65.2257ZM30.1605 62.4515H31.5476V63.8386H30.1605V62.4515Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1621 54.1289H31.5492V59.6773H30.1621V54.1289Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6445 54.1289H44.0316V59.6773H42.6445V54.1289Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3223 62.4512H39.8707V63.8383H34.3223V62.4512Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3223 49.9668H39.8707V51.3539H34.3223V49.9668Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3114_3068",
    x1: 52.0979,
    y1: -6.0847,
    x2: 41.3966,
    y2: 103.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthIcon);
export default __webpack_public_path__ + "static/media/growthIcon.5e2e98183c0ab52c0288d3e08bbd0c4a.svg";
export { ForwardRef as ReactComponent };